import { render, staticRenderFns } from "./AdminMunicipalities.vue?vue&type=template&id=50af8c7f&scoped=true&"
import script from "./AdminMunicipalities.vue?vue&type=script&lang=js&"
export * from "./AdminMunicipalities.vue?vue&type=script&lang=js&"
import style0 from "./AdminMunicipalities.vue?vue&type=style&index=0&id=50af8c7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af8c7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50af8c7f')) {
      api.createRecord('50af8c7f', component.options)
    } else {
      api.reload('50af8c7f', component.options)
    }
    module.hot.accept("./AdminMunicipalities.vue?vue&type=template&id=50af8c7f&scoped=true&", function () {
      api.rerender('50af8c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminMunicipalities.vue"
export default component.exports